import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTransactionDetails } from "../../../redux/actions/campaignActions";
import Loader from "../../../components/Loader/Loader";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import "../../../components/common/css/campaignview.scss";
import Swal from "sweetalert2";
import PageShell from "../../../components/layout/PageShell";
import PageHead from "../../../components/layout/PageHead";

const Viewtransaction = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const transactionView = useSelector((state) => state.transactionView);
  const { transactionDetails } = transactionView;
  const navigate = useNavigate();
  const id = useParams();
  let token = localStorage.getItem("accessToken");
  const date = new Date(
    transactionDetails?.data?.campaign_transactions[0]?.trasaction_date
  );
  useEffect(() => {
    if (transactionView) {
      if (transactionView?.loading !== undefined) {
        setLoading(transactionView?.loading);
      }
    }
  }, [transactionView]);

  let userId = transactionDetails?.data?.user_id;
  let updatedUserID = userId + 100000000;
  useEffect(() => {
    dispatch(getTransactionDetails(token, id));
  }, []);

  const getDateFormat = (date) => {
    const today = date;
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    return yyyy + "" + mm + "" + dd;
  };

  const handleExportExcel = async () => {
    const token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "reports/transaction",
      headers: {
        "x-access-token": token,
      },
      data: {
        investmentId: transactionDetails?.data?.id,
      },
    };

    axios(config)
      .then(function (response) {
        if (response) {
          setLoading(false);
          var abc = base64ToBlob(response.data, "application/vnd.ms-excel");
          const url = window.URL.createObjectURL(abc);
          const link = document.createElement("a");
          link.href = url;
          const filename =
            getDateFormat(new Date()) +
            "_" +
            transactionDetails?.data?.campaign_transactions[0].id;
          link.setAttribute("download", `${filename}.xlsx`);
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch(function (error) {
        setLoading(false);
        console.error("Export transaction error:", error);
      });
  };
  
  const base64ToBlob = (base64Data, contentType) => {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const saveAsXlsxFile = (response) => {
    var mediaType =
      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
    // var userInp = document.getElementById('base64input');
    var a = document.createElement("a");
    a.href = mediaType + response;
    //a.href = mediaType+userInp;
    a.download = "filename.xlsx";
    a.textContent = "Download file!";
    document.body.appendChild(a);
  };

  return (
    <PageShell><PageHead title="Transaction view" /><div className="single">
      <div className="singleContainer">
        <Loader isLoading={loading} />
        <div className="top">
          <div className="left">
            {/* <div className="editButton">Edit</div> */}
            <h1 className="title">User Information</h1>
            <div className="item">
              <img
                src={
                  transactionDetails?.data?.user?.profilePic == null
                    ? ProfilePic
                    : transactionDetails?.data?.user?.profilePic
                }
                alt=""
                className="itemImg"
              />
              <div className="details">
                <h1 className="itemTitle">
                  {transactionDetails?.data?.user?.firstname}{" "}
                  {transactionDetails?.data?.user?.lastname}
                </h1>
                <div className="detailItem">
                  <span className="itemKey">User ID:</span>
                  <span className="itemValue">{updatedUserID}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Email:</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.user?.email}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Phone:</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.user?.mobile == "null"
                      ? ""
                      : transactionDetails?.data?.user?.mobile}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Amount:</span>
                  <span className="itemValue">
                    ${transactionDetails?.data?.amount}
                  </span>
                </div>
                {transactionDetails?.data?.campaign_transactions?.map(
                  (transaction) => {
                    return (
                      <>
                        <div className="detailItem">
                          <span className="itemKey">Transaction ID</span>
                          <span className="itemValue">
                            {transaction?.transactionId}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Invoice Number</span>
                          <span className="itemValue">
                            {transaction?.invoce_number}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Transaction Status</span>
                          <span className={`status ${"Approved"}`}>
                            Success
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Transaction Date</span>
                          <span className="itemValue">
                            {date?.toDateString()}
                          </span>
                        </div>
                      </>
                    );
                  }
                )}
              </div>
            </div>
          </div>
          <div className="left">
            <h1 className="title">Corporate Information</h1>
            <div className="item">
              <div className="details profile-info">
                <div className="detailItem">
                  <span className="itemKey">Company Name:</span>
                  <span className="itemValue">
                    {
                      transactionDetails?.data?.campaign_detail
                        ?.corporation_legal_name
                    }
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Company Email</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.campaign_detail?.camp_email}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Company Address:</span>
                  <span className="itemValue">
                    {
                      transactionDetails?.data?.campaign_detail
                        ?.registered_address
                    }
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Head Office Address</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.campaign_detail?.city}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Country</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.campaign_detail?.country_id}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">State/Province</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.campaign_detail?.province}
                  </span>
                </div>

                <div className="detailItem">
                  <span className="itemKey">Type Of Enitity:</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.campaign_detail?.entitytype}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Buisness No:</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.campaign_detail?.business}
                  </span>
                </div>

                <div className="detailItem">
                  <span className="itemKey">Fax</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.campaign_detail?.fax}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Crax Acoount</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.campaign_detail?.craax_account}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Date Of Corp</span>
                  <span className="itemValue">
                    {transactionDetails?.data?.campaign_detail?.date_of_incorp}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Year Of Corporation</span>
                  <span className="itemValue">
                    {
                      transactionDetails?.data?.campaign_detail
                        ?.how_many_yearsin_business
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div></PageShell>
  );
};

export default Viewtransaction;
